export default __webpack_public_path__ + "static/media/HotelPic4.456c42d9.jpg";